/**
 * 🧱 Refactor BT Phase 3 — Étape 2 : section « SectionEtapes » d'EditerBonTravailDialog.jsx.
 * JSX déplacé TEL QUEL (ex-L2683-2716, dédenté de 10) ; variables lues via `useBTForm()`
 * (BTFormProvider enrichi par `extra` dans le composant parent). DOM, data-testid, classes, textes inchangés.
 */
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Plus, Trash2 } from 'lucide-react';
import { useBTForm } from '../../BTFormContext';

export function SectionEtapes() {
  const {
    addEtape,
    canDoBonTravailAction,
    form,
    removeEtape,
    type,
    updateEtape,
  } = useBTForm();
  return (
    <>
      {/* Étapes */}
      <Card>
        <CardHeader>
          <div className="flex justify-between items-center">
            <CardTitle className="text-base">Étapes</CardTitle>
            {(!canDoBonTravailAction || canDoBonTravailAction('bon_ajouter_etapes')) && (
              <Button type="button" size="sm" variant="outline" onClick={addEtape}><Plus className="w-3 h-3 mr-1" /> Ajouter</Button>
            )}
          </div>
        </CardHeader>
        <CardContent>
          {form.etapes.length === 0 ? (
            <p className="text-sm text-gray-500">Aucune étape</p>
          ) : (
            <div className="space-y-2">
              {form.etapes.map((e, idx) => (
                // ✅ FIX 2026-04-27: clé stable (pas JSON.stringify, sinon perte de focus à chaque keystroke)
                <div key={e.id || e._id || `etape-${idx}`} className="flex items-center gap-2">
                  <span className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center text-xs font-bold">{e.numero}</span>
                  <Input 
                    value={e.description} 
                    onChange={(ev) => updateEtape(idx, ev.target.value)} 
                    placeholder={`Étape ${e.numero}...`}
                    className="flex-1"
                  />
                  {e.completee && <Badge className="bg-green-100 text-green-800 text-xs">Complétée</Badge>}
                  <Button type="button" variant="ghost" size="sm" onClick={() => removeEtape(idx)}><Trash2 className="w-4 h-4 text-red-500" /></Button>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>

    </>
  );
}
